<template>
  <div class="votedPage">
      <p class="u-color-black e-paragraph">Votre participation a bien été prise en compte.<br>
    Rendez-vous demain pour voter à nouveau !</p>
          <p class="u-color-black e-paragraph" style="padding-top: 0;
    width: 90%;
    margin: auto;
    max-width: 400px;
">La série ayant obtenu le plus de votes sera dévoilée pendant la Cérémonie de Clôture du festival le mercredi 13 octobre et remportera le Prix du Public de la Meilleure Série en Compétition.</p>
  </div>
</template>

<script>

export default {
  components: {
  },
};
</script>

<style lang="scss">
.votedPage {
    p {
        text-align: center;
        padding-bottom: var(--spacing-l);
        padding-top: 20px;

      @include media('>=m') {
        padding-top: 75px;
      }
    }
}
</style>
